import './functions';
import './virtuals';
import { wrapperBuilder } from './build';

export const TargetsUtilsWrapper = wrapperBuilder.build();
